module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/chevron_jump-2eb027fc9238c98d89f1d60f296f4f05.svg";